import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
// BETA 20.96 — production-only crash reporting to Dylan's Sentry project.
// Inert in dev / smoke / bot runs (gated on import.meta.env.PROD); guarded so
// it can never break boot. Must run before render to catch boot-time crashes.
import { initSentry } from "./lib/sentry";
// BETA 15.25 — auto-install global error handlers + heartbeat at boot.
// perfTelemetry.ts runs installGlobalErrorHandlers() on import (idempotent).
// This catches: window.onerror, unhandled promise rejections, heartbeat gaps
// (frozen tile detection), memory pressure. All async, all best-effort.
import "./lib/perfTelemetry";

initSentry();
createRoot(document.getElementById("root")!).render(<App />);
